import React from 'react'
import { Termos } from './styles'
interface TermsProps {
    setIsTermsOpen: (valor: boolean) => void
}

export function Terms({ setIsTermsOpen }: TermsProps) {
    return (
        <Termos>
            Li e concordo com os{' '}
            <button onClick={() => setIsTermsOpen(true)}>
                Termos de uso da Tree
            </button>
        </Termos>
    )
}
